import React from 'react'
import MainHome from '../../components/MainHome'

const Settings = () => {
    return (
        <>
            <div>Settings</div>
        </>
    )
}

export default Settings